import React, { Component } from "react";
import PropTypes from "prop-types";
import ProgressButton from "react-progress-button";
import Utils from "@utils";
import { OrganizationFavoriteGroupsService } from "@services";
import { ReactSelect, Modal } from "../../../../../components";

const initialState = {
	showModal: false,
	groupOptions: [],
	buttonState: "",
	form: {
		migrate: "true",
		destinationGroupId: "",
	},
	settings: {},
	validations: {
		destinationGroupId: "",
	},
};

class RemoveGroupModal extends Component {
	constructor(props) {
		super(props);
		this.state = initialState;
	}

	openModal = settings => {
		const state = { ...this.state };

		state.settings = settings;
		state.showModal = true;

		this.setState(state, this.setGroups);
	};

	setGroups = () => {
		const { settings, form } = this.state;
		const { rawGroups } = this.props;

		const groupOptions = rawGroups
			.filter(group => group.Id !== settings.groupId)
			.map(group => ({ label: group.Name, value: group.Id }));

		form.migrate = groupOptions.length ? "true" : "false";

		this.setState({
			groupOptions,
			form,
		});
	};

	handleOnCancel = () => {
		this.setState(initialState);
	};

	/**
	 * Upon submition, determines if the group will be removed or mmigrated to another group
	 * @param {Object} data the officer group object containg all its relevant data
	 */
	handleOnSubmit = event => {
		event.preventDefault();

		const { form } = this.state;

		if (form.migrate === "true" && !this.validateForm()) {
			this.updateProgressButton("error");
			return;
		}

		this.updateProgressButton("loading");

		if (form.migrate === "true") {
			this.migrateGroup();
		} else {
			this.removeGroup();
		}
	};

	validateForm = () => {
		const { form, validations } = this.state;

		const valid = !!form.destinationGroupId;

		validations.destinationGroupId = valid ? "" : "has-error";

		return valid;
	};

	/** Migrates the group data to another group */
	migrateGroup = () => {
		const { lang } = global;
		const { settings, form } = this.state;

		OrganizationFavoriteGroupsService.migrateGroup({
			id: settings.groupId,
			destinationGroupId: form.destinationGroupId,
		})
			.then(() => {
				this.updateProgressButton("success", () => {
					Utils.notify({
						type: "success",
						message:
							form.migrate !== "true"
								? lang.t("Group deleted successfully")
								: "Group migrated successfully",
						title: lang.t("Success"),
					});

					settings.onSuccess();
					this.handleOnCancel();
				});
			})
			.catch(() => {
				Utils.notify({
					type: "error",
					message: lang.t("Unable to migrate group"),
					title: "Error",
				});

				this.updateProgressButton("error");
			});
	};

	/** Removes the selected group fom the officer groups list */
	removeGroup = () => {
		const { lang } = global;
		const { settings } = this.state;

		OrganizationFavoriteGroupsService.deleteGroup(settings.groupId)
			.then(() => {
				Utils.notify({
					type: "success",
					message: lang.t("Group deleted successfully"),
					title: lang.t("Success"),
				});

				this.updateProgressButton("success", () => {
					settings.onSuccess();
					this.handleOnCancel();
				});
			})
			.catch(() => {
				Utils.notify({
					type: "error",
					message: lang.t("Error deleting group"),
					title: "Error",
				});

				this.updateProgressButton("error");
			});
	};

	updateProgressButton = (value, callback) => {
		this.setState({ buttonState: value }, callback);
	};

	handleOnChange = (property, type) => event => {
		const { form, validations } = this.state;
		let value = "";

		switch (type) {
			case "field":
				value = event.target.value;
				break;

			case "select":
				value = event ? event.value : null;
				break;

			case "checkbox":
				value = event.target.checked;
				break;

			default:
				break;
		}
		form[property] = value;
		if (validations[property]) {
			validations[property] = null;
		}

		this.setState({ form, validations });
	};

	render() {
		const { lang } = global;
		const { form, validations, showModal, buttonState, groupOptions } = this.state;
		const { groups } = this.props;

		return (
			<Modal
				show={showModal}
				onHide={this.handleOnCancel}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Confirm")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-md-10 col-md-offset-1">
							<Choose>
								<When condition={groups.length > 0}>
									<div className="form-group">
										<label htmlFor="migrate">
											{lang.t(
												"Do you want to migrate existing officer(s) to another group or remove all the officer(s) from the list_",
											)}
										</label>
										<div className="radio">
											<label htmlFor="migrate">
												<input
													type="radio"
													id="radio-migrate-true"
													name="migrate"
													value="true"
													checked={form.migrate === "true"}
													onChange={this.handleOnChange(
														"migrate",
														"field",
													)}
												/>
												{lang.t("Migrate all officers to")}
											</label>
										</div>
										<div
											className={`form-group ${validations.destinationGroupId}`}
										>
											<ReactSelect
												name="destinationGroupId"
												value={form.destinationGroupId}
												isDisabled={form.migrate === "false"}
												onChange={this.handleOnChange(
													"destinationGroupId",
													"select",
												)}
												options={groupOptions}
												isClearable
											/>
										</div>
										<div className="radio">
											<label htmlFor="migrate">
												<input
													type="radio"
													id="radio-migrate-false"
													name="migrate"
													value="false"
													checked={form.migrate === "false"}
													onChange={this.handleOnChange(
														"migrate",
														"field",
													)}
												/>
												{lang.t("Remove all officers")}.
											</label>
										</div>
									</div>
								</When>
								<Otherwise>
									{`
										${lang.t("All officers from this group will be removed_")}
										${lang.t("Are you sure_")}
									`}
								</Otherwise>
							</Choose>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						id="cancel-remove-group"
						disabled={buttonState === "loading"}
						onClick={this.handleOnCancel}
					>
						{lang.t("Cancel")}
					</button>
					<ProgressButton
						id="remove-group-confirm"
						className="btn btn-primary btn-medium"
						state={buttonState}
						onClick={this.handleOnSubmit}
					>
						{lang.t("Confirm")}
					</ProgressButton>
				</Modal.Footer>
			</Modal>
		);
	}
}

RemoveGroupModal.propTypes = {
	groups: PropTypes.array,
	rawGroups: PropTypes.array,
};

RemoveGroupModal.defaultProps = {
	groups: [],
	rawGroups: [],
};

export default RemoveGroupModal;
